import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/user/user/user/userChatTitle/list',
    method: 'post',
    data
  })
}

export function getUserLimit(data) {
  return request({
    url: '/user/user/userUser/getUserProductInfo',
    method: 'post',
    data
  })
}



export function addImgInfo(data) {
  return request({
    url: '/user/user/user/userChatContent/addWidthAndHeight',
    method: 'post',
    data
  })
}

export function topTask(data) {
  return request({
    url: '/user/user/user/userChatContent/workToTop',
    method: 'post',
    data,
    loading: false,
    transformRequest: (data) => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



export function downloadWatermark(data) {
  return request({
    url: '/user/user/user/userChatContent/downloadWatermark',
    method: 'post',
    data
  })
}

export function downloadWatermarkForAlbum(data) {
  return request({
    url: '/user/user/user/album/downloadWatermarkForAlbum',
    method: 'post',
    data
  })
}





export function getUserRight() {
  return request({
    url: '/user/user/user/actionMenu/getActionMenu',
    method: 'post'

  })
}



export function delById(data) {
  return request({
    url: '/user/user/user/userChatTitle/delById',
    method: 'post',
    data,
    loading: false,
    transformRequest: (data) => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user/userChatTitle.js